module.exports = __webpack_public_path__ + "img/lifeiot-full.ad0a7728.png";